import { render, staticRenderFns } from "./0_Presentation.vue?vue&type=template&id=6b46a512&scoped=true&"
import script from "./0_Presentation.vue?vue&type=script&lang=js&"
export * from "./0_Presentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b46a512",
  null
  
)

export default component.exports